import { PipeTransform, TemplateRef } from '@angular/core';

type ColumnTemplateConfig = {
  template: TemplateRef<{ $implicit: unknown }>;
  pipe?: never;
  asyncPipe?: never;
  translate?: never;
};

type ColumnPipeConfig = {
  pipe: PipeTransform;
  template?: never;
  asyncPipe?: never;
  translate?: false;
};

type ColumnAsyncPipeConfig = {
  asyncPipe: PipeTransform;
  template?: never;
  pipe?: never;
  translate?: false;
};

type ColumnPlainConfig = {
  template?: never;
  pipe?: never;
  asyncPipe?: never;
  translate?: boolean;
};

type ColumnRenderConfig =
  | ColumnTemplateConfig
  | ColumnPipeConfig
  | ColumnAsyncPipeConfig
  | ColumnPlainConfig;

export type ColumnConfig = {
  sortable?: boolean;
  translateHeader?: boolean;
  translate?: boolean;
  sortingName?: string;
  invertSorting?: boolean;
} & ColumnRenderConfig;

export class Column {
  displayedProperty: string;

  name?: string;

  pipe?: PipeTransform;

  asyncPipe?: PipeTransform;

  template?: TemplateRef<{ $implicit: unknown }>;

  translateHeader: boolean;

  sortable: boolean;

  sortingName: string;

  translate: boolean;

  invertSorting: boolean;

  constructor(displayedProperty: string, name?: string, config?: Partial<ColumnConfig>) {
    this.displayedProperty = displayedProperty;
    this.name = name;
    this.pipe = config?.pipe;
    this.asyncPipe = config?.asyncPipe;
    this.template = config?.template;
    this.translateHeader = config?.translateHeader ?? true;
    this.translate = config?.translate ?? false;
    this.sortable = config?.sortable ?? false;
    this.sortingName = config?.sortingName ?? displayedProperty;
    this.invertSorting = config?.invertSorting ?? false;
  }
}
